var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.175 0.75H13.5C13.5 0.3 13.2 0 12.75 0C12.3 0 12 0.3 12 0.75H6C6 0.3 5.7 0 5.25 0C4.8 0 4.5 0.3 4.5 0.75H0.825C0.375 0.75 0 1.125 0 1.575V17.175C0 17.625 0.375 18 0.825 18H17.175C17.625 18 18 17.625 18 17.175V1.575C18 1.125 17.625 0.75 17.175 0.75ZM16.5 16.5H1.5V6H16.5V16.5ZM16.5 5.25H1.5V2.25H4.5V3C4.5 3.45 4.8 3.75 5.25 3.75C5.7 3.75 6 3.45 6 3V2.25H12V3C12 3.45 12.3 3.75 12.75 3.75C13.2 3.75 13.5 3.45 13.5 3V2.25H16.5V5.25Z",
    fill: "#4B4E75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72481 13.2748C8.02481 13.5748 8.4748 13.5748 8.7748 13.2748L11.8498 10.1998C12.1498 9.89981 12.1498 9.4498 11.8498 9.1498C11.5498 8.8498 11.0998 8.8498 10.7998 9.1498L8.2498 11.7748L7.19981 10.7248C6.89981 10.4248 6.4498 10.4248 6.1498 10.7248C5.8498 11.0248 5.8498 11.4748 6.1498 11.7748L7.72481 13.2748Z",
    fill: "#4B4E75"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.ebb1e3cdadb47a51fe924be32b42c6b6.svg";
export { ForwardRef as ReactComponent };